var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sello",class:'sello--' + _vm.estadoReal,attrs:{"title":_vm.texto}},[_c('span',{staticClass:"sello__punto"}),_vm._v(" "),_c('span',{staticClass:"sello__texto"},[_vm._v(_vm._s(_vm.texto)),(_vm.nota)?[_vm._v(" · "+_vm._s(_vm.nota))]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }